import { getFramework, IFramework } from '@/framework';
import { ILayerProps } from '@/version-types';

/** svip 水印 */
export class SvipWatermarkPlugin {
    private type = 'svip-watermark';

    private framework: IFramework;
    private watermarkData: Map<number, { watermarkLayers: ILayerProps[]; isGlobal: boolean }>;

    constructor(private id: string) {
        this.framework = getFramework(id);
        this.watermarkData = new Map();
    }

    /** 获取水印数据 */
    getWatermarkData() {
        return this.watermarkData;
    }

    /** 设置水印图片 */
    setWatermarkImage(image: string) {
        this.framework.setCustomData(this.type, image);
    }

    /** 获取水印图片 */
    getWatermarkImage() {
        return this.framework.getCustomData(this.type) as string;
    }

    /** 渲染激活图层水印 */
    setActiveLayerWatermark(needRender: boolean) {
        this.framework.events.emit(this.type, this.watermarkData, needRender);
    }

    /** 渲染水印 */
    renderWatermark(
        data?: Map<
            number,
            {
                watermarkLayers: ILayerProps[];
                isGlobal: boolean;
            }
        >,
    ) {
        this.watermarkData = data ?? new Map();
        this.framework.events.emit(this.type, this.watermarkData);
    }

    /**
     * 监听水印数据
     * data 为空时，渲染激活图层水印
     */
    onWatermark(
        fn: (
            data: Map<number, { watermarkLayers: ILayerProps[]; isGlobal: boolean }>,
            activeLayerWatermark?: boolean,
        ) => void,
    ) {
        return this.framework.events.on(this.type, fn);
    }
}
